import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SystemApi from "../../../api/sys";
import { Table } from "antd";
import RenderTxt from "@components/renderTxt";
import moment from "moment";
import SearchForm from "@components/SearchForm";
import { stationApi } from "../../../api/newApi";

const Taizhang = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [loading, setLoading] = useState(false);
  const [tableSource, setTableSource] = useState([]);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [inputList] = useState([
    {
      label: "名称:",
      name: "deviceName",
      message: "请输入名称",
      span: 8,
      labelCol: 6,
    },
  ]);
  const [selectList, setSelectList] = useState([
    {
      attr: { allowClear: true },
      label: "业务类型:",
      name: "deviceBusinessType",
      message: "请选择业务类型",
      options: [],
      span: 8,
      labelCol: 6,
    },
    {
      attr: { allowClear: true },
      label: "工艺单元:",
      name: "processunitId",
      message: "请选择工艺单元",
      options: [],
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "名称",
      dataIndex: "deviceName",
      align: "center",
      key: "deviceName",
    },
    {
      title: "物料型号",
      dataIndex: "deviceModel",
      align: "center",
      key: "deviceModel",
      render: (text) => RenderTxt(text),
    },
    {
      title: "设备规格",
      dataIndex: "dossierSpec",
      align: "center",
      key: "dossierSpec",
      render: (text) => RenderTxt(text),
    },
    {
      title: "设备位号",
      dataIndex: "itemNumber",
      align: "center",
      key: "itemNumber",
      render: (text) => RenderTxt(text),
    },
    {
      title: "业务类型",
      dataIndex: "deviceBusinessType",
      align: "center",
      key: "deviceBusinessType",
      render: (text) => RenderTxt(text),
    },
    {
      title: "物料名称",
      dataIndex: "materielName",
      align: "center",
      key: "materielName",
      render: (text) => RenderTxt(text),
    },
    {
      title: "投入运营时间",
      dataIndex: "insTime",
      align: "center",
      key: "insTime",
      render: (text) =>
        text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "购置时间",
      dataIndex: "purchaseTime",
      align: "center",
      key: "purchaseTime",
      render: (text) =>
        text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "供应商",
      dataIndex: "deviceFactory",
      align: "center",
      key: "deviceFactory",
      render: (text) => RenderTxt(text),
    },
    {
      title: "维保周期",
      dataIndex: "maintenanceCycle",
      align: "center",
      key: "maintenanceCycle",
      render: (text) => RenderTxt(text),
    },
  ];

  useEffect(() => {
    getDeviceBusinessType();
    getProcessList();
  }, []);

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  const getListByPages = () => {
    setLoading(true);
    SystemApi.listDeviceLedgerInfo({ ...searchParams, stationId }).then(
      (res) => {
        setLoading(false);
        if (res.status !== "0") return;
        const { data } = res.data;
        data.map((item, index) => {
          item.key = index + 1;
        });
        setTableSource(res.data);
      },
    );
  };

  const getProcessList = () => {
    stationApi.findProcessByStationId(stationId).then((res) => {
      if (res.status !== "0") return;
      const index = selectList.findIndex(
        (item) => item.name === "processunitId",
      );
      selectList[index].options = res.data.map((item) => ({
        title: item.processunitName,
        value: item.processunitId,
      }));
      setSelectList([...selectList]);
    });
  };

  const getDeviceBusinessType = () => {
    SystemApi.selectWithClassifyKeys({
      classifyKeys: ["deviceBusinessType"],
    }).then((res) => {
      if (res.status !== "0") return;
      const { deviceBusinessType = [] } = res.data;
      const index = selectList.findIndex(
        (item) => item.name === "deviceBusinessType",
      );
      selectList[index].options = deviceBusinessType.map((item) => ({
        title: item.disName,
        value: item.disName,
      }));
      setSelectList([...selectList]);
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    const params = {
      ...values,
      pageNum: 1,
      pageSize: 10,
    };
    setSearchParams(params);
  };

  return (
    <div>
      <SearchForm
        span={6}
        inputList={inputList}
        selectList={selectList}
        onSearch={search}
      />
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Taizhang);
